export function hasNotTag(items, tag)
{
	return _.filter(items, item =>
	{
		const tagIds = _.map(item.tags, 'tag.id');

		return !_.includes(tagIds, tag);
	});
}
